module.exports = __webpack_public_path__ + "static/media/pdf.dcfb6e97.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/pdf.gif
// module id = 432
// module chunks = 0